import { forwardRef, ReactNode } from 'react';
import { Button, IconButton, IconButtonProps } from '@mui/material';

interface MIconButtonProps extends IconButtonProps {
  children: ReactNode;
}

const MIconButton = forwardRef<HTMLButtonElement, MIconButtonProps>(({ children, ...other }, ref) => (
  <Button sx={{}}>
    <IconButton ref={ref} {...other}>
      {children}
    </IconButton>
  </Button>
));

export default MIconButton;
